module.exports = __webpack_public_path__ + "static/img/enterprise2.a216c585.png";